import { render, staticRenderFns } from "./SpcDocuments.vue?vue&type=template&id=66e61397&scoped=true"
import script from "./SpcDocuments.vue?vue&type=script&lang=js"
export * from "./SpcDocuments.vue?vue&type=script&lang=js"
import style0 from "./SpcDocuments.vue?vue&type=style&index=0&id=66e61397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e61397",
  null
  
)

export default component.exports